export function removePlusSign(phone) {
  if (phone) {
    return phone.replace(/^\+/, "");
  }
}
